import {
  API_ANALYTICS_NEW_USER_COUNT,
  API_ANALYTICS_PROJECT_COUNT_BY_APPLICATION,
  API_ANALYTICS_PROJECT_COUNT_BY_MAP,
  API_ANALYTICS_PROJECT_COUNT_BY_PRODUCT,
} from "../../urls";

export const SOCIAL_MEDIA_LINKS = {
  facebook: "https://www.facebook.com/uniracinc/",
  twitter: "https://twitter.com/Unirac",
  linkedin: "https://www.linkedin.com/company/unirac-inc-/",
  instagram: "https://www.instagram.com/uniracsolar/",
  youtube: "https://www.youtube.com/user/uniracsolar1/",
};

export const ListOfAnalytics = [
  {
    id: "project_count_by_map",
    name: "Map type count",
    dataset: [],
    mapType: "pie",
    api: API_ANALYTICS_PROJECT_COUNT_BY_MAP,
  },
  // {
  //   id: "application_count",
  //   name: "Application count",
  //   dataset: [],
  //   mapType: "bar",
  //   api: API_ANALYTICS_PROJECT_COUNT_BY_APPLICATION,
  // },
  {
    id: "new_user_count",
    name: "New User count",
    dataset: [],
    mapType: "line",
    api: API_ANALYTICS_NEW_USER_COUNT,
  },
  {
    id: "count_by_product",
    name: "Product Count",
    dataset: [],
    mapType: "bar",
    api: API_ANALYTICS_PROJECT_COUNT_BY_PRODUCT,
  },
];
